import { NotFoundError } from 'onboarding/classes/errors/NotFoundError'

export type TSearchId = { partnerId: string } | { locationId: string }
type TPayload = { searchId: TSearchId; [p: string]: any }

export class PartnerNotFoundError extends NotFoundError {
  public readonly name = this.constructor.name
  public readonly payload: TPayload

  constructor(message: string, payload: TPayload) {
    super(message)
    this.payload = payload
  }

  public getSearchId(): TSearchId {
    return this.payload.searchId
  }
}
